import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Scope } from '@garmin-avcloud/avcloud-fly-web-common/admin-authorization';
import { map, Observable, take } from 'rxjs';
import { LdapTokenService } from '../../../core/services/ldap-token/ldap-token.service';

@Injectable({
  providedIn: 'root'
})
export class AircraftLibraryWriteGuard {
  private readonly tokenService = inject(LdapTokenService);

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.tokenService.hasScopes([Scope.AIRCRAFT_LIBRARY_MAKES_EDIT, Scope.AIRCRAFT_LIBRARY_MODELS_EDIT]).pipe(
      take(1),
      map(([hasAircraftMakesEditAuthorization, hasAircraftModelsEditAuthorization]) =>
        this.allowAccess(state.url, hasAircraftMakesEditAuthorization, hasAircraftModelsEditAuthorization)
      )
    );
  }

  allowAccess(
    url: string,
    hasAircraftMakesEditAuthorization: boolean,
    hasAircraftModelsEditAuthorization: boolean
  ): boolean {
    if (this.isAircraftMakeProtectedUrl(url)) {
      return hasAircraftMakesEditAuthorization;
    } else if (this.isAircraftModelProtectedUrl(url)) {
      return hasAircraftModelsEditAuthorization;
    } else {
      return true;
    }
  }

  isAircraftMakeProtectedUrl(url: string): boolean {
    if (url.includes('aircraft-makes') && this.containsProtectedUrlSegments(url)) {
      return true;
    }
    return false;
  }

  isAircraftModelProtectedUrl(url: string): boolean {
    if (url.includes('aircraft-models') && this.containsProtectedUrlSegments(url)) {
      return true;
    }
    return false;
  }

  containsProtectedUrlSegments(url: string): boolean {
    const protectedUrls = ['add', 'edit'];
    return protectedUrls.some((testUrl) => url.endsWith(testUrl));
  }
}
